import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import classNames from 'classnames';
import { GamesFiltersMenu } from './games-filters-menu';
import { GamesSearchInput } from './games-search-input';

const APPEAR_Y_COORDINATE = 650;

export class GamesFiltersMenuSticky extends PureComponent {
  static propTypes = {
    isOpenSearch: PropTypes.bool.isRequired
  };

  state = {
    isSticky: false,
  };

  scrollSubscription;

  componentDidMount() {
    this.scrollSubscription = fromEvent(window, 'scroll')
      .pipe(map(() => window.pageYOffset >= APPEAR_Y_COORDINATE))
      .subscribe(this.setSticky);
  }

  componentWillUnmount() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  setSticky = isSticky => this.setState({ isSticky });

  render() {
    const { isSticky } = this.state;
    const { isOpenSearch, ...restProps } = this.props;

    return (
      <div
        className={classNames('position-fixed sticky bg-light bg-switch-dark', {
          'sticky-show': isSticky,
        })}
      > {isOpenSearch ? (
        <GamesSearchInput {...restProps} />
      ) : (
        <GamesFiltersMenu {...restProps} isStickyHeader />
      )}
      </div>
    );
  }
}
